module.exports = __webpack_public_path__ + "assets/img/LTC005.d2e4f0e7.png";